import {cx} from "@emotion/css";

import {ReactComponent as SvgBmClockIcon} from "~/assets/svg/clock.svg";
import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmClockIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgBmClockIcon id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
